import { chain, isEmpty } from 'underscore';

export const countTextAssets = ({ collectionObj, countEmpty = false }) => chain(collectionObj).values().filter(textValue => countEmpty || !isEmpty(textValue)).value().length;

export const hasTextAssets = (headlines, longHeadlines, descriptions) => countTextAssets({ collectionObj: headlines }) + countTextAssets({ collectionObj: longHeadlines }) + countTextAssets({ collectionObj: descriptions }) > 0;

const collectionSummary = (element, i18n) => {
  const { collection, displayText, displayTextSingular } = element;

  const count = countTextAssets({ collectionObj: collection });
  const itemText = count === 1 && displayTextSingular ? displayTextSingular : displayText;

  return (i18n.getString(_TL_('{{collectionCount}} {{displayText}}', { comment: 'Collection Count can be 2 and Display Text can be headlines' }), { displayText: itemText, collectionCount: count }));
};

export const getTextCardSummaryDetails = (collectionsSummary, i18n) => {
  const summaryDetails = [];
  collectionsSummary.forEach((element) => {
    summaryDetails.push(collectionSummary(element, i18n));
  });
  return summaryDetails.join(' ');
};

export const getTextCardSummaryDetailsForCollection = (i18n, collection, displayText, displayTextSingular) => collectionSummary({ collection, displayText, displayTextSingular }, i18n);

export const getHeadlinesCardSummaryDetails = (i18n, headlines) => getTextCardSummaryDetailsForCollection(i18n, headlines, i18n.getString(_TL_('short headlines')), i18n.getString(_TL_('short headline')));
export const getLongHeadlinesCardSummaryDetails = (i18n, longHeadlines) => getTextCardSummaryDetailsForCollection(i18n, longHeadlines, i18n.getString(_TL_('long headlines')), i18n.getString(_TL_('long headline')));
export const getDescriptionsCardSummaryDetails = (i18n, descriptions) => getTextCardSummaryDetailsForCollection(i18n, descriptions, i18n.getString(_TL_('descriptions')), i18n.getString(_TL_('description')));
